"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useScrollingIntent;

var _react = require("react");

var _useWindowScrolling = _interopRequireDefault(require("./useWindowScrolling"));

var resolveElementRef = function resolveElementRef(ref) {
  if (typeof ref === 'function') {
    var ret = ref();
    return ret && ret.current;
  }

  return ref && ref.current;
};

function useScrollingIntent(params) {
  var callback = params.callback,
      isListening = params.isListening,
      triggerElementRef = params.triggerElementRef,
      _params$threshold = params.threshold,
      threshold = _params$threshold === void 0 ? 20 : _params$threshold;
  var horizontalPosition = (0, _react.useRef)();
  var verticalPosition = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (isListening) {
      if (triggerElementRef) {
        var target = resolveElementRef(triggerElementRef);

        var _target$getBoundingCl = target.getBoundingClientRect(),
            top = _target$getBoundingCl.top,
            left = _target$getBoundingCl.left;

        verticalPosition.current = top;
        horizontalPosition.current = left;
      } else {
        verticalPosition.current = window.scrollY;
        horizontalPosition.current = window.scrollX;
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isListening]);
  (0, _useWindowScrolling["default"])(function (event) {
    if (triggerElementRef) {
      var target = resolveElementRef(triggerElementRef);

      var _target$getBoundingCl2 = target.getBoundingClientRect(),
          top = _target$getBoundingCl2.top,
          left = _target$getBoundingCl2.left;

      var hasScrolledVertically = Math.abs(top - verticalPosition.current) > threshold;
      var hasScrolledHorizontally = Math.abs(left - horizontalPosition.current) > threshold;

      if (hasScrolledVertically || hasScrolledHorizontally) {
        callback(event);
      }
    } else {
      var _hasScrolledVertically = Math.abs(window.scrollY - verticalPosition.current) > threshold;

      var _hasScrolledHorizontally = Math.abs(window.scrollX - horizontalPosition.current) > threshold;

      if (_hasScrolledVertically || _hasScrolledHorizontally) {
        callback(event);
      }
    }
  }, isListening);
}